<template>
  <v-card class="skeleton-box" :flat="flat">
    <slot>
    </slot>
  </v-card>
</template>
<script>
export default {
  props: {
    delay: {
      type: Number,
      default: 0,
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  .skeleton-box {
    overflow: hidden;
    position: relative;
  }
  .skeleton-box:after {
    top: 0;
    left: 0;
    width: 15%;
    right: 0;
    bottom: 0;
    filter: blur(7px);
    content: '';
    opacity: .3;
    position: absolute;
    transform-origin: 50% 50%;
    animation-name: moveItMoveIt;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    transform: skew(-40deg) translateX(-800%);
    background-color: white;
    box-shadow: 0px 0px 6px 7px white;
  }
  @keyframes moveItMoveIt {
    0% {
      transform: skew(-40deg) translateX(-800%);
    }
    100% {
      transform: skew(-40deg) translateX(800%); 
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/global/skeletons/SkeletonBox.vue